import apiClient from './base.api'
const BASE_ENDPOINT = window.config.PORTAL_BASE_ENDPOINT

export const fetchAppSettingAsync = async(key = null) => {
  const response = await apiClient.get(`${BASE_ENDPOINT}app-settings/${key ? `?key=${key}` : ''}`)

  return response
}
